import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { LegalMentions } from './LegalMentions';
import { goBack } from 'react-router-redux';

const mapStateToProps = state => ({
  strings: getTranslate(state.locale),
});

const mapDispatchToProps = dispatch => ({
  pop: () => dispatch(goBack())
});

export default connect(mapStateToProps, mapDispatchToProps)(LegalMentions);
